import React from 'react';
import classnames from 'classnames/bind';
import AddButton from '@COMPONENTS/COMMON/buttons/AddButton';
import styles from './actionButton.module.scss';

const cx: CX = classnames.bind(styles);

function ActionButton(props: ActionButtonProps) {
    const {
        buttonText, variant, handleClick, icon, tooltipTitle, isActive, locked, showbadge, badgeCount,
    } = props;

    const shouldShowBadge = showbadge && badgeCount !== undefined && badgeCount > 0;

    return (
        <div className={cx('action-button-wrapper', { 'active-button': isActive })}>
            <AddButton
                title={buttonText}
                onClick={handleClick}
                locked={locked || false}
                size="small"
                icon={!!icon}
                iconType={icon || 'plus'}
                tooltipTitle={tooltipTitle || ''}
                fontSize={12}
                isActive={isActive}
            />
            {shouldShowBadge && (
                <div className={cx('badge-counter')}>
                    {badgeCount > 99 ? '99+' : badgeCount}
                </div>
            )}
        </div>
    );
}

ActionButton.defaultProps = {
    variant: 'outlined',
    icon: undefined,
    tooltipTitle: '',
    isActive: false,
    locked: false,
    showbadge: false,
    badgeCount: undefined,
};

interface ActionButtonProps {
    buttonText: string;
    variant?: 'text' | 'outlined' | 'contained';
    handleClick: () => void;
    icon?: 'preview' | 'settings' | 'clock' | 'grid' | 'list' | 'edit' | 'mandatory' | 'pagebreck' | 'landscape' | 'delete';
    tooltipTitle?: string;
    isActive?: boolean;
    locked?: boolean;
    showbadge?: boolean;
    badgeCount?: number;
}

export default ActionButton;
